import React from "react";
import { Sparkles, Leaf, Timer, PackageCheck } from "lucide-react";
import Testimonials from "../db/Testimonials";
import Carousel from "../components/Carousel";

const WhyNestora = () => {
  return (
    <div className="flex flex-col items-center justify-center mb-4 mt-5">
      <div className="text-center">
        <h1 className="text-4xl font-semibold mb-3">Why Choose Nestora?</h1>
        <p className="text-gray-700">
          We're committed to providing exceptional quality, sustainability, and
          service in everything we do
        </p>
      </div>
      <div className="flex flex-wrap justify-center items-center gap-12 mt-4 mb-4">
        <div className="w-[300px]  flex flex-col items-center">
          <Sparkles className="bg-slate-50 text-violet-800  hover:text-white hover:bg-violet-600  rounded-full w-12 h-12 p-2" />
          <h2 className="text-2xl font-semibold">High-quality Materials</h2>
          <p className="text-gray-700 text-center">
            Carefully selected premium materials that ensure durability and
            timeless beauty
          </p>
        </div>
        <div className="w-[300px]  flex flex-col items-center">
          <Leaf className="bg-slate-50 text-violet-800  hover:text-white hover:bg-violet-600  rounded-full w-12 h-12 p-2" />
          <h2 className="text-2xl font-semibold">Sustainable & Eco-friendly</h2>
          <p className="text-gray-700 text-center">
            Committed to sustainable practices and environmentally conscious
            manufacturing
          </p>
        </div>
        <div className="w-[300px] flex flex-col items-center">
          <Timer className="bg-slate-50 text-violet-800  hover:text-white hover:bg-violet-600  rounded-full w-12 h-12 p-2" />
          <h2 className="text-2xl font-semibold">Fast Delivery </h2>
          <p className="text-gray-700 text-center">
            Quick and reliable shipping with real-time tracking and white-glove
            service
          </p>
        </div>
        <div className="w-[300px] flex flex-col items-center">
          <PackageCheck className="bg-slate-50 text-violet-800  hover:text-white hover:bg-violet-600  rounded-full w-12 h-12 p-2" />
          <h2 className="text-2xl font-semibold">30-day Returns</h2>
          <p className="text-gray-700 text-center">
            Try our furniture in your space with our hassle-free return policy
          </p>
        </div>
      </div>
      <hr className="w-[100%] h-[1.5px] mt-2 bg-violet-400 "></hr>
      <div className="text-center mt-12 max-md:w-screen">
        <h1 className="text-4xl font-semibold mb-3">What Our Customers Say</h1>
        <p className="text-gray-700">Real experiences from our valued customers who have transformed their spaces with Nestora</p>
        <div> 
          <Carousel slides={Testimonials}/>
          
        </div>
      </div>
    </div>
  );
};

export default WhyNestora;
